<div class="file-upload-container" [class.error]="hasError">
    @if (label) {
        <label class="upload-label">{{ label }} @if (required)
            {
                <span class="required-star">*</span>
            }
        </label>
    }

    @if (selectedFiles.length === 0 || multiple) {
        <div class="upload-area"
            [class.dragging]="isDragging"
            [class.has-files]="selectedFiles.length > 0 && multiple"
            (dragover)="onDragOver($event)"
            (dragleave)="onDragLeave($event)"
            (drop)="onDrop($event)"
            (click)="fileInput.click()">
            <input #fileInput type="file" [accept]="accept" [multiple]="multiple" (change)="onFileSelected($event)" hidden>
            <div class="upload-content">
                <hugeicons-icon [icon]="uploadIcon" [size]="48" color="currentColor" class="upload-icon"></hugeicons-icon>
                <div class="upload-text">
                    <span class="highlight">Click to upload</span> or drag and drop
                </div>
                <div class="upload-hint">{{ hint || 'PDF, JPG, PNG (up to 25MB)' }}</div>
            </div>
        </div>
    }

    <!-- Single File Preview (outside upload-area, styled as card) -->
    @if (selectedFiles.length > 0 && !multiple) {
        <input #fileInput type="file" [accept]="accept" (change)="onFileSelected($event)" hidden>
        <div class="file-info">
            <div class="file-icon-wrap">
                <hugeicons-icon [icon]="fileIcon" [size]="20" color="currentColor"></hugeicons-icon>
            </div>
            <div class="file-meta">
                <div class="file-name" [title]="selectedFiles[0].name">{{ selectedFiles[0].name }}</div>
                <div class="file-size">{{ formatSize(selectedFiles[0].size) }}</div>
            </div>
            <div class="file-actions">
                <button type="button" class="btn-icon btn-view" (click)="previewFile(selectedFiles[0], $event)" title="Preview">
                    <hugeicons-icon [icon]="viewIcon" [size]="16" color="currentColor"></hugeicons-icon>
                </button>
                <button type="button" class="btn-icon btn-remove" (click)="removeFile(0, $event)" title="Remove">
                    <hugeicons-icon [icon]="closeIcon" [size]="16" color="currentColor"></hugeicons-icon>
                </button>
            </div>
        </div>
    }

    <!-- Multi File List (only if multiple) -->
    @if (selectedFiles.length > 0 && multiple) {
    <div class="file-list-container">
        @for (file of selectedFiles; track file; let i = $index) {
            <div class="file-info">
                <div class="file-icon-wrap">
                    <hugeicons-icon [icon]="fileIcon" [size]="20" color="currentColor"></hugeicons-icon>
                </div>
                <div class="file-meta">
                    <div class="file-name" [title]="file.name">{{ file.name }}</div>
                    <div class="file-size">{{ formatSize(file.size) }}</div>
                </div>
                <div class="file-actions">
                    <button type="button" class="btn-icon btn-view" (click)="previewFile(file, $event)" title="Preview">
                        <hugeicons-icon [icon]="viewIcon" [size]="16" color="currentColor"></hugeicons-icon>
                    </button>
                    <button type="button" class="btn-icon btn-remove" (click)="removeFile(i, $event)" title="Remove">
                        <hugeicons-icon [icon]="closeIcon" [size]="16" color="currentColor"></hugeicons-icon>
                    </button>
                </div>
            </div>
        }
    </div>
    }
    @if (allowNone) {
    <div class="optional-toggle">
        <label class="checkbox-container">
            <input type="checkbox" (change)="toggleNone($event)" [checked]="isNone">
            <span class="checkmark"></span>
            None available
        </label>
    </div>
    }
</div>
